import { useTile } from "web/hooks/data"
import Tile from "../Tile/Tile"
import { openSSRTileSettingsModal } from "../helpers"

export default function StatisticsTile({
  canEdit = true,
  isTemplate,
  overview,
  tileFetchParams,
  subjectType,
  subjectId,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const handleTileSettings = openSSRTileSettingsModal({
    isTemplate,
    overviewId: overview.id,
    tileId: tileFetchParams.id,
    tileType: "statistics",
    subjectType,
    subjectId,
  })

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const maxRows = tile.height === 1 ? 10 : Infinity
  const statistics = (tile.statistics || []).slice(0, maxRows)

  let columnCount
  if (tile.width === 1) {
    columnCount = tile.dimensions.length === 0 ? 0 : 2
  } else {
    columnCount = tile.dimensions.length + 1
  }

  function DimensionHeaders() {
    return (
      <>
        <div className="justify-self-end p-0.5"></div>
        {tile.dimensions.slice(0, columnCount - 1).map((dimension) => {
          return (
            <div
              className={
                "line-clamp-2 w-full p-0.5 text-right text-sm font-semibold"
              }
              key={dimension.id}
            >
              {dimension.label || dimension.field_label}
            </div>
          )
        })}
      </>
    )
  }

  function Row({ statistic }) {
    return (
      <div
        className={
          "col-span-full grid grid-cols-subgrid items-center border-t border-gray-50 p-1"
        }
      >
        <div className="flex min-w-0 items-center text-sm text-gray-500">
          <span className="truncate">{statistic.label}</span>
        </div>
        {tile.dimensions.slice(0, columnCount - 1).map((dimension) => {
          const value = statistic.values?.[dimension.value]
          return (
            <div className="justify-self-end text-sm" key={dimension.id}>
              {value || "-"}
            </div>
          )
        })}
      </div>
    )
  }

  function StatisticsTable() {
    const gridTemplateColumns = `2fr ${Array(columnCount - 1)
      .fill("1fr")
      .join(" ")}`

    return (
      <div
        className={"grid min-w-0 max-w-full"}
        style={{ gridTemplateColumns: gridTemplateColumns }}
      >
        <DimensionHeaders />
        {statistics.map((statistic) => (
          <Row key={statistic.id} statistic={statistic} />
        ))}
      </div>
    )
  }

  function EmptyState() {
    return (
      <div className="flex h-full items-center justify-center px-10 py-0 text-center italic text-neutral-7">
        {tile.empty_state_message}
      </div>
    )
  }

  return (
    <Tile
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileFetchParams.id}
      title={tile.name}
      canEdit={canEdit}
    >
      {tile.empty_state_message === null ? <StatisticsTable /> : <EmptyState />}
    </Tile>
  )
}
